import { render, staticRenderFns } from "./userBlock.vue?vue&type=template&id=91cbeb38&scoped=true&"
import script from "./userBlock.vue?vue&type=script&lang=js&"
export * from "./userBlock.vue?vue&type=script&lang=js&"
import style0 from "./userBlock.vue?vue&type=style&index=0&id=91cbeb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cbeb38",
  null
  
)

export default component.exports